import {
  AppointmentType,
  AppointmentTypeLocation,
  findAppointmentTypeInList,
} from '../api/models';

export interface LocationOptions {
  value: string;
  label: string;
  description: string;
}

export const AllLocations = 'All';

export const getLocationOptionsFromAppointmentType = (
  appointmentTypeList: AppointmentType[] | undefined,
  appointmentTypeId: string | undefined
): LocationOptions[] => {
  const locationList = findAppointmentTypeInList(
    appointmentTypeList,
    appointmentTypeId
  )?.locationList;
  return getLocationOptionsFromLocationList(locationList);
};

export const getLocationOptionsFromLocationList = (
  locationList: AppointmentTypeLocation[] | undefined
): LocationOptions[] => {
  const locationOptions = locationList
    ? locationList.map((location) => {
        const description = [
          location.streetAddress1 ?? '',
          location.streetAddress2 ?? '',
          `${location.city}, ${location.state} ${location.zip}`,
        ].reduce((accumulator, current) => {
          return current ? accumulator + ' ' + current : accumulator;
        });
        return {
          value: location.id ?? '',
          label: location.friendlyLocationName ?? '',
          description: description ?? '',
        };
      })
    : [];
  if (locationOptions.length > 1) {
    // add the "Any location" option to the front
    locationOptions.unshift({
      value: AllLocations,
      label: 'Any location',
      description: 'Schedule at any location the care provider practices at.',
    });
  }

  return locationOptions;
};
